import { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  DRAWER_MENU_KEYS,
  DRAWER_MENU_PERMISSION,
  DRAWER_MENU_RENAMED,
} from '~/config/_idm'
import { useTimezoneStore } from '~/store/timezone'
import useAuth from '~/utils/auth/useAuth'

const useCustom = () => {
  const { userData, handleLogout, idmRoutesUsers } = useAuth()
  const { push } = useHistory()

  const handleChangePageIDM = (path: string) => () => {
    push(path)
  }

  const orgCode = userData?.userOrg?.orgCode.toLowerCase()
  const { timezone, setTimezone } = useTimezoneStore()

  useEffect(() => {
    if (orgCode === 'xapiens') {
      setTimezone(8)
    } else {
      setTimezone(7)
    }
  }, [orgCode])

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChangeTimeZone = useCallback(
    (thisTimezone) => () => {
      setTimezone(thisTimezone)
      handleClose()
    },
    []
  )

  const profileName = useMemo(() => userData?.userName || '', [userData])
  const IDMMenuItems = useMemo(() => {
    return idmRoutesUsers
      .filter((route) => route.shownOnMenu)
      .map((route) => ({
        ...route,
        permission:
          route.id === DRAWER_MENU_KEYS.SETTING
            ? 'ALL'
            : DRAWER_MENU_PERMISSION[route.id],
        title:
          route.id === DRAWER_MENU_KEYS.SETTING
            ? profileName
            : DRAWER_MENU_RENAMED[route.id],
      }))
  }, [idmRoutesUsers, profileName])
  return {
    anchorEl,
    IDMMenuItems,
    handleChangeTimeZone,
    handleClick,
    handleClose,
    handleChangePageIDM,
    handleLogout,
    profileName,
    timezone,
  }
}

export default useCustom
